<template>
    <AppLayout page="/subscriptions" pageTitle="Subscriptions">
        <Link :href="`/store`">
            <jet-button class="ml-4" :class="['gradient-orange white--text']">
                {{ `Products` }}
            </jet-button>
        </Link>
    </AppLayout>
</template>

<script>
import AppLayout from "./../Layouts/AppLayout.vue";
import JetButton from "@/Jetstream/Button.vue";
import { Link } from "@inertiajs/vue2";

export default {
    props: ["prices"],
    components: {
        AppLayout,
        JetButton,
        Link,
        // SoliHeader
    },
};
</script>
$
